module.exports = __webpack_public_path__ + "assets/GoldIota.594417d453a981492ff438e8512d34ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldIota.png
// module id = 763
// module chunks = 0